

    <div id="header">

      <div *ngIf="showAcceptToc" style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 20px; align-items: center;">
        <div style="display: flex; flex-wrap: wrap; gap: 15px; flex-direction: column; row-gap: 5px;" >
          <div>
            Please review the <a href="/terms-of-service">Terms of Service</a>
          </div>
          <div *ngIf="this.acceptedVersions.length > 1" style="font-size: 10px;">* Your continued use of this app also constitutes acceptance of the updated Terms of Service.</div>
          <div *ngIf="this.acceptedVersions.length <= 0" style="font-size: 10px;">* Your continued use of this app also constitutes acceptance of the current Terms of Service.</div>
        </div>

        <button (click)="iReviewed()" style="max-width: 6rem; padding: 2px; max-height: 34px;">Accept</button>
      </div>



      <div style="margin-top: 25px;" *ngIf="emulatedUserId">
        Emulated User
        <img (click)="clearEmulatedUser()"  src="../../../assets/icons8-remove-30.png" alt="image">
      </div>

      <!-- Dashboard button row - separate from main header -->
      <div *ngIf="this.isLoggedIn && this.isOnHomePage" style="display: flex; justify-content: flex-end; margin-top: 15px; margin-bottom: 15px;">
        <button (click)="goToDashboard()" class="dashboard-button" style="white-space: nowrap;">Go To Dashboard</button>
      </div>

      <div style="display: flex; flex-wrap: nowrap; justify-content: space-between; margin-top: 25px; align-items: center;">


        <div class="brand-container">
          <!-- add back menu!! -->
          <!-- <span *ngIf="this.isLoggedIn" (click)="openmenu()" class="menu dropdown dropbtn"><svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16px" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
          </span> -->
          <!-- New logo on the left -->
          <img *ngIf="brand !== 'santa schedule'" class="brand-logo" src="../../../assets/new_logo.png" alt="brand logo">
          
          <!-- Mobile brand name only -->
          <h1 *ngIf="brand == 'Pooper Scoop HQ'" (click)="goHome()" style="margin: 0px; color: var(--brand-color);" class="name brand-name-mobile">{{brand}}</h1>
          <h1 *ngIf="brand == 'santa schedule'" (click)="goHome()" style="margin: 0px; color: var(--brand-color); font-family: var(--brand-font-family); font-weight: 700;" class="name brand-name-mobile"><span style="margin-right: 7px;">merry</span><span style="color: var(--red);">manage</span></h1>
          
           <div (click)="goHome()" style="display: flex; flex-direction: column;" class="brand-text-container">
            <h1 *ngIf="brand == 'Pooper Scoop HQ'" style="margin-bottom: 0px; color: var(--brand-color); margin-left: 0px; margin-top: 0px;" class="name">{{brand}}</h1>
            <h1 *ngIf="brand == 'santa schedule'" style="margin-bottom: 0px; color: var(--brand-color); margin-left: 0px;font-family: var(--brand-font-family); font-weight: 700; margin-top: 0px;" class="name"><span style="margin-right: 7px; font-family: var(--brand-font-family);">merry</span><span style="color: var(--red);">manage</span></h1>

            <span *ngIf="brand == 'santa schedule'" style="margin-top: 10px; font-size: 14px; letter-spacing: 1px; white-space: nowrap;">christmas light installer app</span>
            <span *ngIf="brand == 'Pooper Scoop HQ'" style="margin-top: 10px; font-size: 14px; letter-spacing: 1px; white-space: nowrap;">pooper scooper app</span>
           </div>

        </div>



        <div *ngIf="!this.isLoggedIn" style="display: flex; flex-wrap: wrap-reverse; justify-content: end; flex-grow: 1">

          <!-- <button class="login loginbutton" style="min-width: 9rem;"  id="smp-create-account-btn-demo" >
            <span>Try Sample App</span>
          </button> -->

          <!-- if they are not logged in and they are not on the login page, they are on the home page -->
          <button *ngIf="!this.isLoggedIn && !this.isOnLoginPage" class="login loginbutton" type="submit" (click)="goToLoginPage()">Login</button>

        </div>


        <!-- <div class="help-tip">
          <img *ngIf="this.isLoggedIn && !this.isOnLoginPage" class="imagelogo" src="../../../assets/icons8-project-setup-100.png" alt="image">
          <p>The defaults that will be used for all the upcoming events
          </p>
        </div> -->

        <div *ngIf="this.isLoggedIn && !this.isOnLoginPage" style="display: flex; gap: 0.5rem; margin-top: 0px;">

          <ul style="margin: 0px; padding: 0px; margin-right: 45px;">
            <li style="margin: 0px; padding: 0px">
<img class="imagelogo" style="width: 35px; height: 35px;" src="../../../assets/icons8-settings-50.png" alt="image">                  <ul class="dropdown">

                    <button (click)="goToSettings()">Settings </button>
                    
                    <!-- <button *ngIf="!showSettings" style="pointer-events: auto; transition: opacity 0.1s ease;" [disabled]="true" title="Not accessible with your current role. Please ask your admin.">Settings (Not allowed)</button> -->
                    <!-- <button (click)="openMenu()">Menu</button> -->
                    <button (click)="logout()">Logout</button>
                </ul>
                </li>
            </ul>
        </div>

      </div>
    </div>


